module.exports = "https://static.wanderu.com/ui-react/_next/static/media/apple-badge.8c4986ee.svg";